export const REGISTRATION_STORAGE_KEYS = {
  EMAIL: 'EmailRegister',
  FROM_LOGIN_VALIDATION: 'fromLoginValidation',
  ACCOUNT_TYPE: 'accountTypeNew',
  PERSONA_FORM: 'personaFormNew',
  EMPRESA_FORM: 'empresaFormNew',
  USER_SKILLS: 'userSkillsNew',
  WORK_ZONES: 'workZonesNew',
  ALL_COUNTRY: 'allCountryNew',
  USER_IMAGE: 'userImageNew',
} as const;

export const DEFAULT_SKILL_NAME = 'Otros';

export const DEFAULT_SKIP_ONBOARDING_DATA = {
  accountType: 'PERSON',
  personaForm: {
    name: 'Usuario',
    lastName: 'Edify',
    tel: '',
    webSite: ''
  },
  empresaForm: {
    companyName: 'Empresa Edify',
    tel: '',
    webSite: ''
  },
  userSkills: [],
  workZones: [],
  allCountry: true
};

export const PASSWORD_VALIDATION = {
  MIN_LENGTH: 8,
  REQUIRE_LETTER: true,
  REQUIRE_NUMBER: true,
} as const;

export const CODE_LENGTH = 6;

export const RESEND_CODE_COUNTDOWN = 60;
